import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /*! @noflip */\n  left: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Desktop, Heading, Mobile, Portal, Text, useWindowSize } from "@miro-site/core";
import styled from "styled-components";
import React, { useState } from "react";
import { useTheme } from "styled-components";
import ActionsOverlay from "./components/ActionsOverlay";
import CardDescription from "./components/CardDescription";
import CardImage from "./components/CardImage";
var StyledHeading = styled(Heading).attrs({
    as: "div",
    $variant: "h4",
    $styles: {
        position: "absolute",
        maxWidth: 168,
        top: 32,
        zIndex: 1
    }
}).withConfig({
    componentId: "sc-65201fc7-0"
})(_templateObject());
var HighlightedCard = function(_param) {
    var metadataId = _param.metadataId, templateActions = _param.templateActions, templatePagePath = _param.templatePagePath, className = _param.className, title = _param.title, description = _param.description, templateImage = _param.templateImage, templateImageForMobile = _param.templateImageForMobile, previewButton = _param.previewButton, actionButtonProps = _param.actionButtonProps, accessConstraints = _param.accessConstraints, appSlug = _param.appSlug, position = _param.position, tags = _param.tags, // Avoid passing these props to <Box />
    _metadataId = _param.metadataId, _newBoardMetadataId = _param.newBoardMetadataId, props = _object_without_properties(_param, [
        "metadataId",
        "templateActions",
        "templatePagePath",
        "className",
        "title",
        "description",
        "templateImage",
        "templateImageForMobile",
        "previewButton",
        "actionButtonProps",
        "accessConstraints",
        "appSlug",
        "position",
        "tags",
        "metadataId",
        "newBoardMetadataId"
    ]);
    var ref = useState(false), showDescription = ref[0], setShowDescription = ref[1];
    var theme = useTheme();
    var windowSize = useWindowSize();
    var isMobileViewport = windowSize.width && windowSize.width < theme.breakpoints.small;
    var ref1 = useState(false), isOverlayVisible = ref1[0], setOverlayVisible = ref1[1];
    var getContainerHandlers = function() {
        if (isMobileViewport) {
            return {
                onClick: function() {
                    setOverlayVisible(true);
                }
            };
        }
        return {
            onMouseEnter: function() {
                return setOverlayVisible(true);
            },
            onMouseLeave: function() {
                return setOverlayVisible(false);
            }
        };
    };
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        className: className
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
                $styles: {
                    position: "relative",
                    height: 0,
                    paddingTop: [
                        "64.307%",
                        "59.090%"
                    ]
                }
            }, getContainerHandlers()), {
                children: [
                    /*#__PURE__*/ _jsx(CardImage, {
                        onShowCardDescription: function() {
                            return setShowDescription(true);
                        },
                        image: _object_spread_props(_object_spread({}, templateImage), {
                            width: 550,
                            height: 325
                        }),
                        mobileImage: _object_spread_props(_object_spread({}, templateImageForMobile), {
                            width: 325,
                            height: 209
                        }),
                        priority: position === 0,
                        wrapperStyles: {
                            marginBottom: [
                                12,
                                null,
                                null,
                                null
                            ],
                            borderRadius: [
                                8,
                                16,
                                16,
                                16
                            ],
                            position: "absolute",
                            overflow: "hidden",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "grey"
                        }
                    }),
                    /*#__PURE__*/ _jsxs(Desktop, {
                        $block: true,
                        children: [
                            /*#__PURE__*/ _jsx(StyledHeading, {
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(ActionsOverlay, {
                                metadataId: metadataId,
                                templateActions: templateActions,
                                templatePagePath: templatePagePath,
                                previewButton: previewButton,
                                actionButtonProps: actionButtonProps,
                                onMoreInfoClick: function() {
                                    return setShowDescription(true);
                                },
                                isVisible: isOverlayVisible
                            })
                        ]
                    }),
                    isMobileViewport ? /*#__PURE__*/ _jsx(Portal, {
                        children: /*#__PURE__*/ _jsx(CardDescription, {
                            metadataId: metadataId,
                            templateActions: templateActions,
                            templatePagePath: templatePagePath,
                            isShown: showDescription,
                            isFullscreen: true,
                            title: title,
                            tags: tags,
                            previewButton: previewButton,
                            actionButtonProps: actionButtonProps,
                            description: description,
                            thumbnail: templateImage,
                            onClose: function() {
                                return setShowDescription(false);
                            },
                            popupStyles: {
                                position: "fixed",
                                top: 0,
                                right: 0,
                                left: 0,
                                height: "100%",
                                overflow: "auto",
                                zIndex: 701,
                                paddingTop: [
                                    64,
                                    null,
                                    null,
                                    null
                                ],
                                paddingRight: [
                                    20,
                                    null,
                                    null,
                                    null
                                ],
                                paddingBottom: [
                                    43,
                                    null,
                                    null,
                                    null
                                ],
                                paddingLeft: [
                                    20,
                                    null,
                                    null,
                                    null
                                ]
                            }
                        })
                    }) : /*#__PURE__*/ _jsx(CardDescription, {
                        metadataId: metadataId,
                        templateActions: templateActions,
                        templatePagePath: templatePagePath,
                        isShown: showDescription,
                        previewButton: previewButton,
                        actionButtonProps: actionButtonProps,
                        title: title,
                        tags: tags,
                        description: description,
                        thumbnail: templateImage,
                        onClose: function() {
                            return setShowDescription(false);
                        },
                        descriptionStyles: {
                            overflow: "auto",
                            maxHeight: [
                                null,
                                200,
                                200,
                                200
                            ]
                        },
                        popupStyles: {
                            position: "absolute",
                            overflow: "visible",
                            width: "100%",
                            paddingTop: [
                                null,
                                40,
                                40,
                                40
                            ],
                            paddingRight: [
                                null,
                                90,
                                90,
                                90
                            ],
                            paddingBottom: [
                                null,
                                40,
                                40,
                                40
                            ],
                            paddingLeft: [
                                null,
                                40,
                                40,
                                40
                            ],
                            top: 0,
                            left: 0
                        }
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(Mobile, {
                children: /*#__PURE__*/ _jsx(Text, {
                    as: "div",
                    $variant: "p1",
                    $styles: {
                        fontWeight: 700
                    },
                    children: title
                })
            })
        ]
    }));
};
export default HighlightedCard;
